module.exports = __webpack_public_path__ + "static/logo-49fd3f484981e18c6d915dbee433e767.png";